import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";

interface StaticsProps {
    courseStuCount: number;
    doneNumber: number;
    unDoneNumber: number;
    current: string;
    onChange: (select: string) => void;
}

export default function Statics({
    courseStuCount,
    doneNumber,
    unDoneNumber,
    current,
    onChange
}: StaticsProps) {
    return (
        <div className={style.root}>
            <div
                className={classNames(style.statics, {
                    [style.active]: current === ""
                })}
                onClick={() => onChange("")}>
                <em>{courseStuCount}</em>课程人数
            </div>
            <div
                className={classNames(style.statics, {
                    [style.active]: current === "1"
                })}
                onClick={() => onChange("1")}>
                <em>{doneNumber}</em>已学习
            </div>
            <div
                className={classNames(style.statics, {
                    [style.active]: current === "0"
                })}
                onClick={() => onChange("0")}>
                <em>{unDoneNumber}</em>未学习
            </div>
        </div>
    );
}
